import {
  Component,
  HostListener,
  Injector,
  ViewChild,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { TranslateDirective, TranslatePipe } from '@embraceit/angularcore/tms';
import { CommonModule, Location } from '@angular/common';
import { DialogService } from 'primeng/dynamicdialog';
import { PlanningPortalBaseComponent } from '../../../base/planning-portal-base/planning-portal-base.component';
import { DiscardUnsavedChangesComponent } from '../../../shared/discard-unsaved-changes/discard-unsaved-changes.component';
import { TableModule } from 'primeng/table';
import { ProgressBarModule } from 'primeng/progressbar';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { MasterPlansState } from '../../state/master-plan.state';
import { lastValueFrom, Observable, takeUntil } from 'rxjs';
import { ImportJobsCSVUseCase } from 'planning-portal-library/src/lib/core/usecases/plans';
import { ValidateJLCsvFileResponse } from 'planning-portal-library/src/lib/core/domain/requests/plans/ValidateJLCsvFileResponse';
import { Select, Selector } from '@ngxs/store';
import { JobUsingCsv } from 'planning-portal-library/src/lib/core/domain/models/JobUsingCsv';
import { LocationUsingCsv } from 'planning-portal-library/src/lib/core/domain/models/LocationUsingCsv';
import { FormsModule } from '@angular/forms';
import { Plan } from 'planning-portal-library/src/lib/core/domain';
import { TabsModule } from 'primeng/tabs';
import { ButtonModule } from 'primeng/button';
import { Popover } from 'primeng/popover';
import { ChipModule  } from 'primeng/chip';
import { InputText } from 'primeng/inputtext';
import { BadgeModule } from 'primeng/badge';
@Component({
    selector: 'planning-portal-job-import-panel',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        FormsModule,
        TabsModule,
        TableModule,
        ProgressBarModule,
        CheckboxModule,
        MultiSelectModule,
        Popover,
        TranslatePipe,
        ButtonModule,
        ChipModule,
        InputText,
        BadgeModule,
        DropdownModule
    ],
    templateUrl: './job-import-panel.component.html',
    styles: [],
    providers: [DialogService]
})
export class JobImportPanelComponent extends PlanningPortalBaseComponent {
  @Select(MasterPlansState.SelectedValidatedJLData) $JLData:
    | Observable<ValidateJLCsvFileResponse>
    | undefined;
  @ViewChild('distribution') distributionDropdown: any;
  @ViewChild('vehicle') vehicleDropdown: any;
  @ViewChild('product') productDropdown: any;
  
  // Popover references
  @ViewChild('jobsPanel') jobsPanel!: Popover;
  @ViewChild('locationsPanel') locationsPanel!: Popover;
  @ViewChild('filterPanel') filterPanel!: Popover;
  @ViewChild('jobIdFilterPanel') jobIdFilterPanel!: Popover;
  @ViewChild('nameFilterPanel') nameFilterPanel!: Popover;
  @ViewChild('endLocationFilterPanel') endLocationFilterPanel!: Popover;
  @ViewChild('distributionPanel') distributionPanel!: Popover;
  @ViewChild('vehiclePanel') vehiclePanel!: Popover;
  @ViewChild('locationStatusPanel') locationStatusPanel!: Popover;
  @ViewChild('locationJobIdPanel') locationJobIdPanel!: Popover;
  @ViewChild('locationIdFilterPanel') locationIdFilterPanel!: Popover;
  @ViewChild('locationAddressPanel') locationAddressPanel!: Popover;
  @ViewChild('productPanel') productPanel!: Popover;
  
  //products = [{ name: 'Pharma' }, { name: 'option 2' }, { name: 'option 3' }];
  selectedOptions: any[] = [];

  constructor(
    inject: Injector,
    private browserLocation: Location,
    private importJobsCSVUseCase: ImportJobsCSVUseCase,
    private cdr: ChangeDetectorRef
  ) {
    super(inject);
  }
  jobStatusSelected = 0;
  locationStatusSelected = 0;
  jobsCount = 0;
  locationCount = 0;
  totalJobs = 0;
  totalErrorsInJobs = 0;
  totalSuccessInJobs = 0;
  totalWarningsInJobs = 0;
  totalLocations = 0;
  totalSuccessInLocations = 0;
  totalErrorsInLocations = 0;
  totalWarningsInLocations = 0;
  activeIndex = 0;
  jlData: any;
  jobs: JobUsingCsv[] = [];
  locations: LocationUsingCsv[] = [];
  appliedFiltersJobs: any[] = [];
  appliedFiltersLocations: any[] = [];
  progressBarValue = 0;
  isLocationFilterApplied = false;

  isJobFilterApplied = false;
  vehicles: any[] = [];
  selectedDistribution: any = null;
  selectedVehicle: any = null;
  distributionList: any[] = [];
  products: any[] = [];
  selectedPlan!: Plan;
  filterStatusLocations: string[] = ['1', '2'];
  filterJobs = {
    status: [
      // { id: 0, name: 'All', checked: false },
      { id: 1, name: 'Error', checked: false },
      { id: 2, name: 'Warning', checked: false },
      { id: 3, name: 'Success', checked: false },
    ],
    jobID: '',
    startlocation: '',
    endlocation: '',
    vehicleName: '',
    distributionAreaName: '',
  };
  filterLocations = {
    status: [
      { id: 1, name: 'Error', checked: false },
      { id: 2, name: 'Warning', checked: false },
      { id: 3, name: 'Success', checked: false },
    ],
    jobID: '',
    locationid: '',
    locationaddress: '',
    product: [],
  };

  ngOnInit() {
    this.$JLData!.pipe(takeUntil(this.destroyer$)).subscribe((data) => {
      this.jlData = data;
      if (this.jlData) {
        this.jobs = this.jlData?.jobs || this.jobs;
        this.locations = this.jlData?.locations || this.locations;
      }

      this.jobs.forEach((vehicle) => {
        if (
          this.vehicles.filter((a) => a.name == vehicle.vehicleName).length == 0
        )
          this.vehicles.push({
            id: vehicle.vehicleType?.toString(),
            name: vehicle.vehicleName?.toString(),
          });
      });
      this.jobs.forEach((distributionArea) => {
        if (
          this.distributionList.filter(
            (a) => a.name == distributionArea.distributionAreaName
          ).length == 0
        )
          this.distributionList.push({
            id: distributionArea.distributionAreaName?.toString(),
            name: distributionArea.distributionAreaName?.toString(),
          });
      });

      this.jobStatusSelected = this.filterJobs.status.filter(
        (a) => a.checked
      ).length;

      this.locationStatusSelected = this.filterLocations.status.filter(
        (a) => a.checked
      ).length;

      this.locations.forEach((product) => {
        if (
          this.products.filter((a) => a.name == product.productName).length == 0
        )
          this.products.push({ name: product.productName?.toString() });
      });
      if (this.jlData) {
        this.jobsCount = this.jlData.jobs.filter(
          (a: any) => a.jobStatus == 3 || a.jobStatus == 2
        ).length;
        this.locationCount = this.jlData.locations.filter(
          (a: any) => a.locationStatus == 3 || a.locationStatus == 2
        ).length;
      }
      this.jobStatusSelected = this.filterJobs.status.filter(
        (a) => a.checked
      ).length;
      this.locationStatusSelected = this.filterLocations.status.filter(
        (a) => a.checked
      ).length;
      this.totalJobs = this.jobs.length;
      this.totalErrorsInJobs = this.jobs.filter((j) => j.jobStatus == 1).length;
      this.totalSuccessInJobs = this.jobs.filter(
        (j) => j.jobStatus == 3
      ).length;
      this.totalWarningsInJobs = this.jobs.filter(
        (j) => j.jobStatus == 2
      ).length;
      this.totalLocations = this.locations.length;
      this.totalErrorsInLocations = this.locations.filter(
        (j) => j.locationStatus == 1
      ).length;
      this.totalSuccessInLocations = this.locations.filter(
        (j) => j.locationStatus == 3
      ).length;
      this.totalWarningsInLocations = this.locations.filter(
        (j) => j.locationStatus == 2
      ).length;
      this.filterLocations.status[0].checked = this.totalErrorsInLocations > 0;
      this.filterLocations.status[1].checked =
        this.totalWarningsInLocations > 0;
      this.filterJobs.status[0].checked = this.totalErrorsInJobs > 0;
      this.filterJobs.status[1].checked = this.totalWarningsInJobs > 0;

      if (this.filterJobs.status.filter((a) => a.checked).length > 0) {
        this.appliedFiltersJobs.push({
          Key: 'Status',
          Value: this.filterJobs.status
            .filter((a) => a.checked)
            .map((a) => a.name)
            .join(', '),
        });
        this.isJobFilterApplied = true;
      }
      if (this.filterLocations.status.filter((a) => a.checked).length > 0) {
        this.appliedFiltersLocations.push({
          Key: 'Status',
          Value: this.filterLocations.status
            .filter((a) => a.checked)
            .map((a) => a.name)
            .join(', '),
        });
        this.isLocationFilterApplied = true;
      }

      this.applyJobsFilter();
      this.applyLocationsFilter();
      if (this.jobs.length > 0) {
        this.getPlanById(this.jobs[0].planId);
      }

      this.selectedPlan = this.store.selectSnapshot(
        MasterPlansState.SelectedPlan
      )!;
      this.cdr.detectChanges();
    });
  }

  moveIndex(index: number) {
    if (index == 1) {
      this.activeIndex = index;
    } else if (index == 0) {
      this.activeIndex = index;
    }
  }

  closeAllPopovers(except?: Popover) {
    const popovers = [
      this.filterPanel,
      this.jobIdFilterPanel,
      this.nameFilterPanel,
      this.endLocationFilterPanel,
      this.distributionPanel,
      this.vehiclePanel,
      this.locationStatusPanel,
      this.locationJobIdPanel,
      this.locationIdFilterPanel,
      this.locationAddressPanel,
      this.productPanel
    ];

    popovers.forEach(popover => {
      if (popover && popover !== except && popover.overlayVisible) {
        popover.hide();
      }
    });
  }

  openFilterPopover(popover: Popover, event: Event) {
    this.closeAllPopovers(popover);
    popover.toggle(event);
    event.stopPropagation();
  }
  
  discardChanges() {
    const schedulerPlanDialogRef = this.dialogService.open(
      DiscardUnsavedChangesComponent,
      {
        data: {
          description:
            'You are about to discard the following action plan. This will discard all unsaved information associated with the plan',
          title: 'Plan:',
          name: this.selectedPlan.name,
        },
        header: 'Unsaved changes',
        closable: true,
        styleClass: 'p-dialog-danger',
        modal: true,
      }
    );

    const clonePlanDialogRefOnCloseSub =
      schedulerPlanDialogRef.onClose.subscribe((res) => {
        if (res) {
          this.browserLocation.back();
        }
      });
    this.subscriptions.push(clonePlanDialogRefOnCloseSub);
  }
  populateAppliedFiltersJobs() {
    this.appliedFiltersJobs = [];

    if (this.filterJobs.status.filter((a) => a.checked).length > 0) {
      this.appliedFiltersJobs.push({
        Key: 'Status',
        Value: this.filterJobs.status
          .filter((a) => a.checked)
          .map((a) => a.name)
          .join(', '),
      });
    }
    if (this.filterJobs.jobID != '' && this.filterJobs.jobID != undefined) {
      this.appliedFiltersJobs.push({
        Key: 'Job Id',
        Value: this.filterJobs.jobID,
      });
    }
    if (
      this.filterJobs.startlocation != '' &&
      this.filterJobs.startlocation != undefined
    ) {
      this.appliedFiltersJobs.push({
        Key: 'start location',
        Value: this.filterJobs.startlocation,
      });
    }
    if (
      this.filterJobs.endlocation != '' &&
      this.filterJobs.endlocation != undefined
    ) {
      this.appliedFiltersJobs.push({
        Key: 'end location',
        Value: this.filterJobs.endlocation,
      });
    }
    if (
      this.filterJobs.distributionAreaName != '' &&
      this.filterJobs.distributionAreaName != undefined
    ) {
      this.appliedFiltersJobs.push({
        Key: 'distribution',
        Value: this.filterJobs.distributionAreaName,
      });
    }
    if (
      this.filterJobs.vehicleName != '' &&
      this.filterJobs.vehicleName != undefined
    ) {
      this.appliedFiltersJobs.push({
        Key: 'vehicle',
        Value: this.filterJobs.vehicleName,
      });
    }
    this.isJobFilterApplied = this.appliedFiltersJobs.length > 0;
  }
  populateAppliedFiltersLocations() {
    this.appliedFiltersLocations = [];

    if (this.filterLocations.status.filter((a) => a.checked).length > 0) {
      this.appliedFiltersLocations.push({
        Key: 'Status',
        Value: this.filterLocations.status
          .filter((a) => a.checked)
          .map((a) => a.name)
          .join(', '),
      });
    }
    if (
      this.filterLocations.jobID != '' &&
      this.filterLocations.jobID != undefined
    ) {
      this.appliedFiltersLocations.push({
        Key: 'Job Id',
        Value: this.filterLocations.jobID,
      });
    }
    if (
      this.filterLocations.locationid != '' &&
      this.filterLocations.locationid != undefined
    ) {
      this.appliedFiltersLocations.push({
        Key: 'location id',
        Value: this.filterLocations.locationid,
      });
    }
    if (
      this.filterLocations.locationaddress != '' &&
      this.filterLocations.locationaddress != undefined
    ) {
      this.appliedFiltersLocations.push({
        Key: 'Location Address',
        Value: this.filterLocations.locationaddress,
      });
    }
    if (this.filterLocations.product.length > 0) {
      this.appliedFiltersLocations.push({
        Key: 'Products',
        Value: this.filterLocations.product.map((a) => a).join(', '),
      });
    }
    this.isLocationFilterApplied = this.appliedFiltersLocations.length > 0;
  }
  applyJobsFilter() {
    this.jobs = this.jlData?.jobs == undefined ? this.jobs : this.jlData?.jobs;
    this.populateAppliedFiltersJobs();
    this.jobs = this.jobs.filter(
      (job) =>
        (this.filterJobs.status.filter((a) => a.checked).length == 0 ||
          this.filterJobs.status
            .filter((a) => a.checked)
            .map((a) => a.id)
            .some((st) => st === job.jobStatus)) &&
        (!this.filterJobs.jobID || job.jobId.includes(this.filterJobs.jobID)) &&
        (!this.filterJobs.startlocation ||
          job.startLocationName
            ?.toLowerCase()
            .includes(this.filterJobs.startlocation.toLowerCase()) ||
          job.startAddress
            ?.toLowerCase()
            .includes(this.filterJobs.startlocation.toLowerCase()) ||
          job.startLocationCity
            ?.toLowerCase()
            .includes(this.filterJobs.startlocation.toLowerCase()) ||
          job.startLocationCountry
            ?.toLowerCase()
            .includes(this.filterJobs.startlocation.toLowerCase())) &&
        (!this.filterJobs.endlocation ||
          job.endLocationName
            ?.toLowerCase()
            .includes(this.filterJobs.endlocation.toLowerCase()) ||
          job.endAddress
            ?.toLowerCase()
            .includes(this.filterJobs.endlocation.toLowerCase()) ||
          job.endLocationCity
            ?.toLowerCase()
            .includes(this.filterJobs.endlocation.toLowerCase()) ||
          job.endLocationCountry
            ?.toLowerCase()
            .includes(this.filterJobs.endlocation.toLowerCase())) &&
        (!this.filterJobs.vehicleName ||
          job.vehicleName == this.filterJobs.vehicleName) &&
        (!this.filterJobs.distributionAreaName ||
          job.distributionAreaName == this.filterJobs.distributionAreaName)
    );
    this.jobStatusSelected = this.filterJobs.status.filter(
      (a) => a.checked
    ).length;
  }
  applyLocationsFilter() {
    this.locations =
      this.jlData?.locations == undefined
        ? this.locations
        : this.jlData?.locations;
    this.populateAppliedFiltersLocations();
    this.locations = this.locations.filter(
      (job) =>
        (this.filterLocations.status.filter((a) => a.checked).length == 0 ||
          this.filterLocations.status
            .filter((a) => a.checked)
            .map((a) => a.id)
            .some((st) => st === job.locationStatus)) &&
        (!this.filterLocations.jobID ||
          job.jobId.includes(this.filterLocations.jobID)) &&
        (!this.filterLocations.locationid ||
          job.locationId
            ?.toLowerCase()
            .includes(this.filterLocations.locationid.toLowerCase())) &&
        (!this.filterLocations.locationaddress ||
          job.locationName
            ?.toLowerCase()
            .includes(this.filterLocations.locationaddress.toLowerCase()) ||
          job.address
            ?.toLowerCase()
            .includes(this.filterLocations.locationaddress.toLowerCase()) ||
          job.city
            ?.toLowerCase()
            .includes(this.filterLocations.locationaddress.toLowerCase()) ||
          job.country
            ?.toLowerCase()
            .includes(this.filterLocations.locationaddress.toLowerCase())) &&
        (this.filterLocations.product.length == 0 ||
          this.filterLocations.product.some(
            (st: string) => st === job.productName
          ))
    );
    this.locationStatusSelected = this.filterLocations.status.filter(
      (a) => a.checked
    ).length;
  }
  async importJobs() {
    this.activeIndex = 3;
    this.generateRandomNumbers();
    const importPlan$ = this.importJobsCSVUseCase.execute(this.jlData);

    const importPlan = await lastValueFrom(importPlan$, {
      defaultValue: undefined,
    });
    if (importPlan) {
      this.messageService.clear();
      this.messageService.add({
        severity: 'success',
        summary: this.translate.instant('common.messages.success.success'),
        detail: this.translate.instant(
          'master_plans.jobs.messages.jl_uploaded_successfully'
        ),
        life: 3000,
      });
      this.moveToNewUpdatePlanRoutesFromRules(this.selectedPlan);
    } else {
      this.messageService.clear();
      this.messageService.add({
        severity: 'error',
        summary: this.translate.instant('common.messages.errors.error'),
        detail: this.translate.instant(
          'master_plans.jobs.messages.jl_uploaded_failed'
        ),
        life: 3000,
      });
    }
  }
  handleNoJobs() {}
  stopProp(event: any) {
    event.stopPropagation();
    event.preventDefault();
  }
  stopTargetProp(event: any) {
    event.originalEvent.stopPropagation();
    event.originalEvent.preventDefault();
  }
  onVehicleChange(event: any) {
    this.filterJobs.vehicleName = event.value.name;
    event.originalEvent.stopPropagation();
    event.originalEvent.preventDefault();
  }

  onDistributionAreaChange(event: any) {
    this.filterJobs.distributionAreaName = event.value.name;
    event.originalEvent.stopPropagation();
    event.originalEvent.preventDefault();
  }

  @HostListener('document:click', ['$event.target'])
  onDocumentClick(target: HTMLElement) {
    // if (this.activeIndex == 0) {
    //   if (
    //     this.distributionDropdown.isOpen() &&
    //     !target.closest('.ngb-dropdown')
    //   ) {
    //     this.distributionDropdown.close();
    //   }
    //   if (this.vehicleDropdown.isOpen() && !target.closest('.ngb-dropdown')) {
    //     this.vehicleDropdown.close();
    //   }
    // }
    // if (this.activeIndex == 1) {
    //   if (this.productDropdown.isOpen() && !target.closest('.ngb-dropdown')) {
    //     this.productDropdown.close();
    //   }
    // }
    console.log('document clicked', target);
  }
  async generateRandomNumbers(): Promise<void> {
    for (let i = 0; i <= 100; i++) {
      let randomNumber = 0;
      randomNumber = Math.floor(Math.random() * 101);
      if (randomNumber < this.progressBarValue && this.progressBarValue < 90) {
        randomNumber = this.progressBarValue + 5;
      }
      if (randomNumber > this.progressBarValue) {
        this.progressBarValue = randomNumber;
        this.cdr.detectChanges();
      }
      await this.delay(500);
    }
  }
  delay(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  filterBtnClicked(event: any, filter: string) {
    this.stopProp(event);
    if (this.activeIndex == 0) {
      if (filter == 'distribution') {
        if (this.vehicleDropdown.isOpen()) {
          this.vehicleDropdown.close();
        }
      }
      if (filter == 'vehicle') {
        if (this.distributionDropdown.isOpen()) {
          this.distributionDropdown.close();
        }
      }
      if (filter == 'notDrop') {
        if (
          this.distributionDropdown.isOpen() ||
          this.vehicleDropdown.isOpen()
        ) {
          this.vehicleDropdown.close();
          this.distributionDropdown.close();
        }
      }
    }
    if (this.activeIndex == 1) {
      if (filter == 'notDrop') {
        if (this.productDropdown.isOpen()) {
          this.productDropdown.close();
        }
      }
    }
  }
  resetJobFilter(i: any) {
    if (this.appliedFiltersJobs[i].Key.toLowerCase() == 'status') {
      this.filterJobs.status.forEach((element) => {
        element.checked = false;
      });
    }
    if (this.appliedFiltersJobs[i].Key.toLowerCase() == 'job id') {
      this.filterJobs.jobID = '';
    }
    if (this.appliedFiltersJobs[i].Key.toLowerCase() == 'start location') {
      this.filterJobs.startlocation = '';
    }
    if (this.appliedFiltersJobs[i].Key.toLowerCase() == 'end location') {
      this.filterJobs.endlocation = '';
    }
    if (this.appliedFiltersJobs[i].Key.toLowerCase() == 'distribution') {
      this.selectedDistribution = null;
      this.filterJobs.distributionAreaName = '';
    }
    if (this.appliedFiltersJobs[i].Key.toLowerCase() == 'vehicle') {
      this.selectedVehicle = null;
      this.filterJobs.vehicleName = '';
    }
    this.jobs = this.jlData.jobs;
    this.applyJobsFilter();
  }
  resetJobFilterField(filterName: string) {
    if (filterName.toLowerCase() == 'status') {
      this.filterJobs.status.forEach((element) => {
        element.checked = false;
      });
    }
    if (filterName.toLowerCase() == 'jobid') {
      this.filterJobs.jobID = '';
    }
    if (filterName.toLowerCase() == 'startlocation') {
      this.filterJobs.startlocation = '';
    }
    if (filterName.toLowerCase() == 'endlocation') {
      this.filterJobs.endlocation = '';
    }
    if (filterName.toLowerCase() == 'distribution') {
      this.filterJobs.distributionAreaName = '';
      this.selectedDistribution = null;
    }
    if (filterName.toLowerCase() == 'vehicle') {
      this.filterJobs.vehicleName = '';
      this.selectedVehicle = null;
    }
    this.jobs = this.jlData.jobs;
    this.applyJobsFilter();
  }
  resetLocationFilterField(filterName: string) {
    if (filterName.toLowerCase() == 'status') {
      this.filterLocations.status.forEach((element) => {
        element.checked = false;
      });
    }
    if (filterName.toLowerCase() == 'jobid') {
      this.filterLocations.jobID = '';
    }
    if (filterName.toLowerCase() == 'locationid') {
      this.filterLocations.locationid = '';
    }
    if (filterName.toLowerCase() == 'locationaddress') {
      this.filterLocations.locationaddress = '';
    }
    if (filterName.toLowerCase() == 'product') {
      this.productDropdown.close();
      this.selectedOptions = [];
      this.filterLocations.product = [];
    }
    this.locations = this.jlData.location;
    this.applyLocationsFilter();
  }
  resetLocationFilter(i: any) {
    if (this.appliedFiltersLocations[i].Key.toLowerCase() == 'status') {
      this.filterLocations.status.forEach((element) => {
        element.checked = false;
      });
    }
    if (this.appliedFiltersLocations[i].Key.toLowerCase() == 'job id') {
      this.filterLocations.jobID = '';
    }
    if (this.appliedFiltersLocations[i].Key.toLowerCase() == 'location id') {
      this.filterLocations.locationid = '';
    }
    if (
      this.appliedFiltersLocations[i].Key.toLowerCase() == 'location address'
    ) {
      this.filterLocations.locationaddress = '';
    }
    if (this.appliedFiltersLocations[i].Key.toLowerCase() == 'products') {
      this.filterLocations.product = [];
    }
    this.jobs = this.jlData.jobs;
    this.applyLocationsFilter();
  }
  onOptionSelected(event: any) {
    this.stopTargetProp(event);
    this.filterLocations.product = event.value.map((a: any) => a.name);
  }
}
